import React from "react";

const TwitterLogo: React.FC = () => (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 40.998"><path fill="none" stroke="#7971fa" stroke-miterlimit="10" d="M20.499 40.497a20 20 0 1 1 20-20 20 20 0 0 1-20 20Z" data-name="Path 10983"/><path fill="#7971fa" d="m21.835 19.022 6.559-7.624h-1.555l-5.69 6.62-4.554-6.62h-5.246l6.879 10.011-6.879 7.995h1.554l6.014-6.991 4.8 6.991h5.246l-7.129-10.382Zm-2.129 2.476-.7-1-5.543-7.93h2.386l4.475 6.4.7 1 5.817 8.321h-2.392l-4.743-6.791Z"/></svg>
);

export default TwitterLogo;
